import { useFormik } from 'formik';
import React from 'react'
import * as Yup from 'yup';
import { UserInformationdocuments as documents } from './documents';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../Components/InputCompo/CustomInput';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import { useQuery } from '@tanstack/react-query';
import { CreateAccountGet } from '../../../Store/auth/createAccount';

const EditUserInformation = ({setActiveStep}) => {
    const email = localStorage.getItem('dummyEmail')

    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: 'createAccount',
        queryFn: () => CreateAccountGet(email ? email : ''),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0,
    });


    const navigate = useNavigate();

    const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
            if (field.type.toLowerCase() !== 'section') {
                let validator = Yup.string(); // Default: Not required

                // Only enforce required validation if mandatory: true
                // if (field.mandatory === 1) {
                //   validator = validator.required(`${field.question} is required`);
                // }                
                if (field.validation) {
                    switch (field.validation.toLowerCase()) {
                        case 'email':
                            validator = Yup.string()
                                .email('Invalid email address')
                                .required('Email is required')
                                .matches(
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                'Invalid email format'
                                )
                            break;
                        case 'mobile':
                            validator = Yup.string()
                                .matches(/^\d{10}$/, "Invalid Number. It should be 10 digit.")
                            break;
                        default:
                            break;
                    }
                }

                schema[field.question_no] = validator;
            } else {

            }

            return schema;
        }, {})
    );

    const formik = useFormik({

        initialValues: fieldLoading || !questions || !questions?.documents ? {
            // Default empty inputs when no API data
            ...documents.reduce((values, field) => {
                const savedData = JSON.parse(localStorage.getItem('createAccount')) || {};
                values[field.question_no] = savedData[field.question_no] || ''; // Use saved data if available, else empty string
                return values;
            }, {})
        } : {
            // Use API data if available
            ...questions?.documents // Dynamically populate the form fields from API
        },
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Convert the form data into a flat object
                const tempData = {
                    ...documents.reduce((acc, field) => {
                        const value = values[field.question_no];
                        // Convert numbers to strings, keep other types as-is
                        acc[field.question_no] = typeof value === 'number' ? String(value) : value;
                        return acc;
                      }, {}),
                };

                // Retrieve existing data from localStorage
                const existingData = JSON.parse(localStorage.getItem('createAccount')) || {};

                // Merge new data with existing data
                const updatedData = {
                    ...existingData,
                    ...tempData,
                };

                // Save updated data to localStorage
                localStorage.setItem('createAccount', JSON.stringify(updatedData));
                setActiveStep(1)

                // Optionally, navigate to the next page or perform another action

            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });


  return (
    <div>
    
                <form action="" onSubmit={formik.handleSubmit}>
                    <div className='flex flex-wrap gap-[30px] justify-between w-[100%] my-5'>
                        {documents?.map(Fields =>
                            <>
                                {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'email' ?
                                    <div className='w-[100%]'>
                                        <CustomInput
                                            required={Fields?.mandatory > 0}
                                            {...formik.getFieldProps(Fields.question_no)}
                                            name={Fields.question_no} label={Fields.question}
                                            onBlur={formik.handleBlur}
                                            type={Fields.type}
                                        />
                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                    </div>
                                    :
                                    Fields.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className='w-[100%]'>
                                            <>
                                                <CustomSelection required={Fields?.mandatory > 0}
                                                    options={Fields?.options}
                                                    {...formik?.getFieldProps(Fields?.question_no)}
                                                    name={Fields.question_no} label={Fields.question}
                                                    noSort={true}
                                                />
                                                {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                        </div>
                                        : ''
                                }
                            </>
                        )}
                    </div>
    
    
                    <div className='flex justify-end'>
                        <div className='flex gap-[20px]'>
                            <Button onClick={() => navigate(-1)} variant='text' disableRipple sx={{ color: '#C00000', fontWeight: 600, textTransform: 'inherit', letterSpacing: '-.5px', fontSize: '14px' }}>Cancel</Button>
                            <Button type='submit' variant='contained' sx={{ backgroundColor: '#C00000', color: 'white', borderRadius: '20px', fontWeight: 600, textTransform: 'inherit', letterSpacing: '-.5px', fontSize: '14px', '&:hover': { backgroundColor: '#ED1C24' } }}>Save & Next</Button>
                        </div>
                    </div>
                    {/* {questions && <div className='flex justify-end mt-2'>
                        <div className='flex gap-[20px]'>
                            <Button onClick={() => setActiveStep(3)}  variant='contained' sx={{backgroundColor:'#004878' , color:'white' , padding:'5px 30px' , borderRadius:'20px', fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px' , '&:hover':{backgroundColor:'#004878'}}}>Register Offer/ Event</Button>
                        </div>
                    </div>} */}
                </form>
            </div>
  )
}

export default EditUserInformation